module.exports = __webpack_public_path__ + "zl6-845192bb.png";